import jwt_decode from 'jwt-decode'
import PropTypes from 'prop-types'
import { createContext, useState, useEffect } from 'react'
import { setTokenGetter } from '../servicios/httpService'
import * as loginService from '../servicios/loginService'

export const LoginContext = createContext()

export const LoginProvider = (props) => {
  const [token, setToken] = useState('')
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  const [loginDataContext, setLoginDataContext] = useState({
    tipo: '',
    nombre: '',
    apellido: '',
    registradoParticular: false,
    tipoUsuario: ''
  })

  // Initialize context from localStorage on app start
  useEffect(() => {
    const storedToken = localStorage.getItem('jwt')
    const storedUser = localStorage.getItem('usuario')
    const storedEmpid = localStorage.getItem('empid')

    if (storedToken && storedUser && storedEmpid) {
      setToken(storedToken)
      setIsAuthenticated(true)

      const decoded = jwt_decode(storedToken)
      updateUserData(decoded)
    }

    // Set up token getter for httpService
    setTokenGetter(() => storedToken || '')
  }, [])

  const setLoginData = (data) => {
    const {
      token: tokenEBM,
      refreshToken,
      empid,
      usuario,
      idUsuario,
      nombre,
      apellido,
      tipo,
      tipoUsuario,
      registradoParticular
    } = data

    // Set authentication tokens
    setLocalStorage(tokenEBM, refreshToken, usuario, empid, idUsuario)

    // Update user context with validated data
    updateUserData({
      nombre: nombre,
      apellido: apellido,
      tipo: tipo,
      tipoUsuario: tipoUsuario,
      registradoParticular: registradoParticular
    })
  }

  const setLocalStorage = (token, refreshToken, usuario, empid, idUsuario) => {
    setToken(token)
    setIsAuthenticated(true)
    // Only store essential auth data in localStorage
    localStorage.setItem('jwt', token)
    localStorage.setItem('refreshToken', refreshToken)
    localStorage.setItem('usuario', usuario)
    localStorage.setItem('empid', empid)
    localStorage.setItem('idUsuario', idUsuario || 0)

    // Update token getter for httpService
    setTokenGetter(() => token)
  }

  const updateUserData = (userData) => {
    // Update context state
    setLoginDataContext((prevState) => ({
      ...prevState,
      ...userData
    }))
  }

  const logout = () => {
    setToken('')
    setIsAuthenticated(false)
    setLoginDataContext({
      tipo: '',
      nombre: '',
      apellido: '',
      registradoParticular: false,
      tipoUsuario: ''
    })
    localStorage.clear()
  }

  const renewToken = async (usuario, empid, refreshToken) => {
    const loginData = {
      usuario: usuario || localStorage.getItem('usuario'),
      empid: empid || localStorage.getItem('empid'),
      refreshToken: refreshToken || localStorage.getItem('refreshjwt')
    }
    const { data } = await loginService.requestToken(loginData)
    if (data.token !== '') {
      setLocalStorage(
        data.token,
        data.refreshToken,
        data.usuario,
        data.empid,
        data.idUsuario
      )
    }
  }

  return (
    <LoginContext.Provider
      value={{
        loginDataContext,
        token,
        isAuthenticated,
        setLocalStorage,
        logout,
        renewToken,
        setLoginDataContext,
        updateUserData,
        setLoginData
      }}
    >
      {props.children}
    </LoginContext.Provider>
  )
}

LoginProvider.propTypes = {
  children: PropTypes.node.isRequired
}
